export default {
  banner: {
    title: "权限管理",
    subtitle:
      "Authing 能帮助企业统一管理分散的在各应用中的权限系统，实现细致到某一行、某一按钮的授权策略，无需大量的开发成本，即可编排自动化的权限治理流程。",
    img: "authority-banner-img.png",
    data1: "统一分散权限",
    data2: "预防数据泄漏",
    data3: "提高审计效率",
    data4: "降低自研成本",
  },
  question: {
    title: "想实现统一权限管理，但自研困难、成本过高？",
    card1: {
      title: "自研系统，困难重重",
      item1: {
        title: "集成困难",
        descript:
          "企业内部各系统使用不同认证授权机制，难以形成统一的权限治理框架。",
      },
      item2: {
        title: "建设不全",
        descript:
          "企业较难找到具备丰富实施经验的人选，来设计完备的权限治理规划。",
      },
      item3: {
        title: "逻辑复杂",
        descript:
          "权限粒度细，涵盖多种资源类型、主体类型和操作权限，实现难度高。",
      },
      item4: {
        title: "回收不及时",
        descript:
          "企业管理员手动维护账，当多个员工入/转/调/离，权限难以及时回收。",
      },
    },
    card2: {
      title: "通过 Authing 一站式解决复杂的权限场景",
      item1: {
        title: "无需自行集成应用",
        descript:
          "Authing 预集成多种应用，企业无需额外开发，即可快速集成不同架构的应用系统至后台统一管理权限。",
      },
      item2: {
        title: "建设具前瞻性的权限体系",
        descript:
          "Authing 经手多家大型企业的权限管理系统建设，有丰富的实施经验，能为企业建设高扩展性的权限体系。",
      },
      item3: {
        title: "灵活适应业务选代",
        descript:
          "企业在 Authing 控制台能自定义资源、操作、主体，灵活地打包成授权策略，让权限逻辑适应复杂的业务。",
      },
      item4: {
        title: "自动化权限分配/回收",
        descript:
          "基于身份自动化平台，自动调整如/转/调/离的人员权限，降低因权限调整不及时导致的安全风险。",
      },
    },
  },
  model: {
    title: "使用 Authing，无需操心复杂的开发逻辑",
    subtitle:
      "Authing 基于 OPA 引擎实现 RBAC 和 ABAC 权限模型，能实现更灵活、更细致的访问控制决策，快速适应业务变化",
    rbac: {
      title: "RBAC 权限模型",
      img: "authority-rbac.jpg",
      subtitle: "基于角色的访问控制",
      item1: {
        title: "什么是 RBAC",
        subtitle:
          "RBAC 指通过用户的角色（Role）授权其相关权限。角色可以被定义为岗位、项目组、部门等，企业只需把角色赋予成员，即可授予成员该角色下的权限。",
      },
      item2: {
        title: "面向场景：中小型企业",
        subtitle:
          "你的企业是中小型企业，外部用户很少，并且组织角色有明确的定义。比起复杂的权限场景，你更需要快速地建立清晰的、扩展性强的权限管理架构。",
      },
      item3: {
        title: "授予角色权限，让权限管理快速适应业务迭代",
        subtitle:
          "在 Authing 控制台中，企业能根据自己的需求创建 API、菜单、按钮等资源，自定义资源操作，如读取、编辑等，让授权策略适应复杂的业务和快速的迭代。",
      },
    },
    abac: {
      title: "ABAC 权限模型",
      subtitle: "基于属性的访问控制",
      img: "authority-abac.jpg",
      item1: {
        title: "什么是 ABAC",
        subtitle:
          "ABAC 指的是在授权资源时，通过「属性」进行条件限制，动态判断一个操作是否被允许。属性包括 IP、请求来源国家、访问时间等。",
      },
      item2: {
        title: "面向场景：大型组织",
        subtitle:
          "你在一个人员流动高、内外部多方协作、重度依赖运营的大型企业中，需要确保隐私安全符合政策监管需求，权限需细致到某一行、某一按钮。",
      },
      item3: {
        title: "限制访问条件，为授权策略增添防护",
        subtitle:
          "对于信息安全要求高的企业，或者高保密级别项目，需要对用户的详细属性如 IP、请求来源、客户设备进行限制，可以使用 Authing 快速实现 ABAC 策略。",
      },
    },
  },
  advantage: {
    title: "构建完善的权限管理体系，满足安全合规需求",
    subtitle:
      "Authing 提供完善的权限管理功能模块，能帮助企业构建细粒度的权限体系，满足安全合规政策需求",
    item1: {
      title: "接入预集成应用，快速实现权限的统一管控",
      img: "authority-feature1.png",
      descript:
        "企业内部系统割裂，不同部门人员使用不同系统，维护各自的权限，容易造成安全隐患。使用 Authing，企业仅需将应用集成在 Authing 控制台，即可统一在该应用对应的权限空间下创建角色、创建资源并进行授权，无需付出额外的应用对接成本。",
    },
    item2: {
      title: "自定义数据资源，轻松实现细粒度授权策略",
      img: "authority-feature2.png",
      descript:
        "受政策或运营形态影响，企业要求敏感信息的权限需具体到某个人只能访问/编辑某一行、某一列，权限逻辑复杂。Authing 将资源抽象成字符串、树结构、数组结构三种类型，几乎能涵盖市面上所有权限管理的场景，企业可以针对自己的需求轻松配置。",
    },
    item3: {
      title: "一键生成权限视图，统一查看人员多应用权限",
      img: "authority-feature3.png",
      descript:
        "权限数据分散在不同系统中，常造成审计负担。Authing 以用户为单位，提供可视化、全局的权限视图，能展示用户在不同应用下的资源权限和关联策略。企业可通过筛选生成多个视图，方便事后审计，减少重复低效的工作。",
    },
    item4: {
      title: "集中鉴权 API 请求 ，确保服务调用的安全性",
      img: "authority-feature4.png",
      descript:
        "不同系统间的 API 鉴权、微服务鉴权和 M2M 场景下，结合 Authing 的权限管理功能和 API 网关，能统一对用户请求的 API 进行拦截并鉴权，在风险出现时拒绝访问，确保服务调用的安全性与合理性。整体对接成本低，业务系统无感知。",
    },
    item5: {
      title: "自动化权限管理，减少手动操作的低效和风险",
      img: "authority-feature5.png",
      descript:
        "当企业内部发生员工入职、离职或组织架构变动时，通过 Authing 自动化权限编排的设置，能自动触发管理流程并进行权限的申请、审批、开关等调整，减少手动操作导致的重复工作，和漏关/错开权限带来的数据泄漏风险。",
      data1: "提升管理效率",
      data2: "降低运维成本",
      data3: "减少安全风险",
      data4: "灵活定义业务流程",
    },
    item6: {
      title: "便捷的 API/SDK，降低权限系统的开发和维护成本",
      img: "authority-feature6.png",
      descript:
        "据统计，自研一个完善的权限管理系统至少需要 6 个月。相反地，Authing 具备完善的权限管理后台和 API/SDK，企业无需从 0 构建，两周即可实现。若未来新增了业务系统，也能通过 Authing 的 PaaS 能力快速扩展相关功能，无需重复建设。",
      data1: "减少开发成本",
      data2: "配合业务拓展",
      data3: "快速适应迭代",
      data4: "最快两周即可实现",
    },
  },
};
